import { ViewDef, GridLayouter, IDivRequest } from "./ah.mb.ui.view-builders";

export interface ILayoutCellObject {
    x, y, w, h: number;
    i, id: string;
    viewName: string;
    viewSubject: string;
}

    /**
     * Vue-Grid based layouter
     */
export class VueGridLayouter implements GridLayouter {

    private target: JQuery;
    private cellObjects: Array<ILayoutCellObject>;
    private cellIdFunc: (string) => string;
    private colCount: number;
    private initialCellCount: number;

    private cellCount: number = 0;

    //private usedCells = 0;

    constructor(cellObjects: Array<ILayoutCellObject>, cellIdFunc: (string) => string, colCount: number,
        initialCellCount: number) {
        this.cellObjects = cellObjects;
        this.cellIdFunc = cellIdFunc;
        this.colCount = colCount;
        this.initialCellCount = initialCellCount;

    }

    /**
     * Creates a layout for a given number of views
     * @param viewCount
     */
    createLayout(target: JQuery, viewDefs: Array<ViewDef>) {
//        this.cellObjects =  //.length = 0;

        this.cellObjects.splice(0, this.cellObjects.length);

        //this.cellObjects.length = 0;
        //this.createCells(0); //(this.initialCellCount);
        //this.usedCells = 0;

        //this.createCells(0); //this.initialCellCount);


    };

    createCells(viewName: string, viewSubject: string) {

        //     var elementId = `node-charts-cell-${this.cellCount}`;


        //this.cellObjects.splice(0, this.cellObjects.length);
        //const targetCellCount = Math.max(viewDefs.length, this.initialCellCount);


//        viewDefs.forEach(viewDef => {

//            while (this.cellObjects.length < targetCellCount) {

                const curCellCount = this.cellObjects.length;

                const cellId = this.cellIdFunc(curCellCount);

                const targetCol = curCellCount % this.colCount;

                const targetRow = Math.floor(curCellCount / this.colCount);

                this.cellObjects.push(
                    {
                        "x": targetCol,
                        "y": targetRow,
                        "w": 1,
                        "h": 1,
                        "i":
                            cellId,
                        id: cellId,
                        viewName: viewName,
                        viewSubject: viewSubject
                    }
                );



                //console.log("cell, targetCol", { targetCol, targetRow });
        //    });

//            while (this.cellObjects.length > targetCellCount) {

//                /*this.cellObjects = */
//                this.cellObjects.splice(this.cellObjects.length - 1, 1);
////            this.cellObjects.length = this.cellObjects.length - 1;

    }


    getDiv(request: IDivRequest): string {

        if (request.columns > 0 && request.rows > 0) {

            this.createCells(request.viewName, request.subjects[0]);
            const cellId = this.cellIdFunc(this.cellObjects.length - 1);
            //this.usedCells ++;

            
            //    { "x": 0, "y": 0, "w": 2, "h": 2, "i": "0", id:"node-charts-cell-0" },
            //    { "x": 2, "y": 0, "w": 2, "h": 4, "i": "1", id: "node-charts-cell-1" },
            //    { "x": 4, "y": 0, "w": 2, "h": 5, "i": "2", id: "node-charts-cell-2" },
            //    { "x": 6, "y": 0, "w": 2, "h": 3, "i": "3", id: "node-charts-cell-3" },
            //    { "x": 8, "y": 0, "w": 2, "h": 3, "i": "4", id: "node-charts-cell-4" },
            //    { "x": 10, "y": 0, "w": 2, "h": 3, "i": "5", id: "node-charts-cell-5" },
            //    { "x": 0, "y": 5, "w": 2, "h": 5, "i": "6", id: "node-charts-cell-6" },
            //    { "x": 2, "y": 5, "w": 2, "h": 5, "i": "7", id: "node-charts-cell-7" },
            //    { "x": 4, "y": 5, "w": 2, "h": 5, "i": "8", id: "node-charts-cell-9" }
            //];

            // Return id of last cell 


            //return $(`#chart-div-${cellId}`);
//            return $(`#${cellId}`);

            return `#${cellId}`;
        }

        return "none";
//        return $('none');
//        return $(`#chart-div-${elementId}`);
    }
}



// WEBPACK FOOTER //
// ./ClientApp/scripts/vue-grid-layouter.ts